module.exports = __webpack_public_path__ + "img/222.7b9b5049.png";